export default __webpack_public_path__ + "static/media/flow_2.9c869ce1.jpg";